import { useSelector } from 'react-redux';
import { useApplicationContext } from '../../utils/applicationContext';
import { selectBuilder } from '../../selectors/builder';
import * as React from 'react';
import { isBuilderWithEscrow } from '../../utils/builder/isBuilderWithEscrow';
import { EscrowBlock } from '../../components/EscrowBlock';

export const EscrowBlockContainer = () => {
  const { config } = useApplicationContext();
  const { id } = useSelector(selectBuilder);

  if (!isBuilderWithEscrow(id, config)) {
    return null;
  }

  return <EscrowBlock />;
};
